import React from 'react';
import type { LookupLimitationPeriodWidgetData } from '../../../types/agentWidgets';

interface Props {
  data: LookupLimitationPeriodWidgetData;
}

export const LookupLimitationPeriodWidget: React.FC<Props> = ({ data }) => {
  if (data.results.length === 0) return null;

  return (
    <div className="mt-1.5 space-y-1">
      <p className="text-[10px] uppercase tracking-wide text-gray-400 dark:text-gray-500 font-medium">
        {data.results.length} limitation period{data.results.length !== 1 ? 's' : ''}
      </p>
      <div className="space-y-1.5">
        {data.results.map((lp) => (
          <div
            key={lp.caseType}
            className="text-[11px] bg-slate-50/70 dark:bg-slate-800/30 rounded px-2.5 py-2 space-y-0.5"
          >
            <div className="flex items-baseline gap-2">
              <span className="font-semibold text-slate-700 dark:text-slate-200">
                {lp.caseType}
              </span>
              <span className="font-bold text-slate-900 dark:text-white">
                {lp.period}
              </span>
            </div>
            <p className="text-slate-500 dark:text-slate-400">
              Starts: {lp.startTrigger}
            </p>
            <p className="text-[10px] text-slate-400 dark:text-slate-500">
              {lp.statutoryBasis}
            </p>
            {lp.notes && (
              <p className="text-[10px] italic text-slate-400 dark:text-slate-500 line-clamp-2">
                {lp.notes}
              </p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
